import script from "./_suggest.vue?vue&type=script&setup=true&lang=js"
export * from "./_suggest.vue?vue&type=script&setup=true&lang=js"

import "./_suggest.vue?vue&type=style&index=0&id=153a8ce6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-153a8ce6"]])

export default __exports__